
<div class="container navtop">


    
    <div class="container mt-3">
        <mat-form-field class="w-100">
          <mat-label>Entrez le code</mat-label>
          <input matInput [(ngModel)]="userCode" (input)="checkCode()" placeholder="">
        </mat-form-field>
      
        <div *ngIf="isCodeValid" class="alert alert-success mt-3">
          ✅ <strong>Code correct :</strong> Le code {{ userCode }} est correcte
        </div>
      
        <div *ngIf="userCode && !isCodeValid" class="alert alert-danger mt-3">
          ❌ <strong>Code incorrect :</strong> Réessayez.
        </div>
      </div>


    <div *ngIf="isCodeValid" class="container mt-3">
        <mat-form-field class="w-100">
          <mat-label>Entrez votre refresh token</mat-label>
          <textarea matInput [(ngModel)]="refresh_token" rows="5"></textarea>
        </mat-form-field>
      
        <button mat-raised-button color="primary" class="mt-2" (click)="getUserWithRefreshToken()">Envoyer</button>
      
        <div *ngIf="refresh_token" class="alert alert-info mt-3">
          <strong>Refresh token :</strong> {{ refresh_token }}
        </div>
      </div>







</div>